import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { GoogleAnalytics } from '../../../../services/analytics';
import { EventPropType } from '../../../analytics/types';
import LikeButton from '../../../engagement/components/LikeButton';
import { LIKE_ANNOTATION } from '../../constants/annotations';
import { updateItemAnnotation, getAnnotationKey } from '../../services/annotations';
var defaultProps = {
  initialLikeCount: 0,
  event: {}
};
function CatalogItemLikeButton(_ref) {
  var businessId = _ref.businessId,
    businessType = _ref.businessType,
    catalogItemId = _ref.catalogItemId,
    initialLikeCount = _ref.initialLikeCount,
    event = _ref.event;
  var key = getAnnotationKey(businessId, businessType, catalogItemId, LIKE_ANNOTATION);
  function onLike(_x, _x2, _x3) {
    return _onLike.apply(this, arguments);
  }
  function _onLike() {
    _onLike = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(likedId, active, recaptchaToken) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            GoogleAnalytics.triggerEvent(event);
            _context.next = 3;
            return updateItemAnnotation(businessId, businessType, likedId, active, recaptchaToken, LIKE_ANNOTATION);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onLike.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(LikeButton, {
    id: catalogItemId,
    storageKey: key,
    onLike: onLike,
    initialLikeCount: initialLikeCount
  });
}
CatalogItemLikeButton.defaultProps = defaultProps;
export default CatalogItemLikeButton;